import StockInicial from "./StockInicial";
export default StockInicial;